// extracted by mini-css-extract-plugin
export default {"saleDetailsView":"SaleDetailsView__saleDetailsView-rhpt"};